// extracted by mini-css-extract-plugin
export default {"required":"auth-required_required__8gzKN","error":"auth-required_error__hYwCJ"};